import React from 'react';
import useUserProfile from '../../customHooks/useUserProfile';
import useTranslate from '../../customHooks/useTranslate';
import { Alert } from '@mui/material';

const ReadOnlyUserAlert = ({ text }: { text?: string }) => {
    const { readOnlyUser } = useUserProfile();
    const readOnlyText = useTranslate(text);

    if (readOnlyUser) {
        return (
            <Alert
                severity='warning'
                sx={{
                    width: '100%',
                    justifyContent: 'center',
                }}
            >
                {readOnlyText}
            </Alert>
        );
    }
    return null;
};

export default ReadOnlyUserAlert;
